// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { TenantConfig } from "../core/models/types";
import * as dashboard from "../RootStore/TenantStore/dashboardTenants";

const US_CO_CONFIG = {
  name: "Colorado",
  stateCode: "CO",
  domain: "state.co.us",
  availableStateCodes: [dashboard.US_CO],
  enableUserRestrictions: false,
  navigation: {
    parole: ["docket"],
  },
  paroleConfig: {
    docketConfig: {
      columns: [
        { header: "Name", field: "individualName", sortable: true },
        { header: "DOC ID", field: "displayId", format: "docId" },
        {
          header: "Hearing Date",
          field: "hearingDate",
          format: "date",
          sortable: true,
        },
        { header: "Hearing Type", field: "hearingType" },
        { header: "Facility", field: "facility" },
      ],
      subheading: "Two Week Outlook",
      searchEnabled: true,
      // CO's scheduled hearing dates are truncated to the 1st of the month in
      // the source table (see us_co/parole_board_client_profile.py), so a
      // hearing set for this month can already be "in the past" by the 2nd.
      // The look-back covers a full month so that date stays on the docket for
      // as long as it's genuinely still this month's hearing.
      windowDaysBefore: 31,
      windowDaysAfter: 14,
    },
    conductHistoryConfig: {
      classificationColors: {
        "Class I": "BLUE",
        "Class IIa": "GREEN",
        "Class IIb": "YELLOW",
        "Class III": "PURPLE",
      },
      visibleYears: 1,
    },
    riskAssessmentConfig: {
      tools: ["LSIR", "PIT", "CARAS", "SRT", "RT", "CST"],
      aggregateView: {
        label: "Entire CTAP Suite",
        tools: ["RT", "SRT", "PIT"],
      },
    },
  },
} satisfies TenantConfig<"US_CO">;

export default US_CO_CONFIG;
